/**
 * Properties API Client
 */

import { BaseApiClient } from './base-client'
import {
  type ApiResponse,
  type Property,
  API_ROUTES,
} from '@super/shared-types'

export class PropertiesApiClient extends BaseApiClient {
  /**
   * Get all properties for a company (Super Admin)
   * @param companyId - The ID of the company to get properties for
   * @returns The properties for the company
   */
  async getAllAdminPropertiesForCompany(
    companyId: string,
  ): Promise<Property[]> {
    const response = await this.request<ApiResponse<Property[]>>(
      `${API_ROUTES.ADMIN.PROPERTIES.GET_BY_COMPANY}?companyId=${companyId}`,
      {
        method: 'GET',
      },
    )

    return response.data || []
  }

  /**
   * Get all properties for the current company
   * Uses session information to determine the company
   * @returns The properties for the current company
   */
  async getProperties(): Promise<Property[]> {
    const response = await this.request<ApiResponse<Property[]>>(
      API_ROUTES.PROPERTIES.GET,
      {
        method: 'GET',
      },
    )

    return response.data || []
  }
}

// Create and export singleton instance
export const propertiesApiClient = new PropertiesApiClient()
